import React from 'react'
import QuestionsCard from './list/QuestionsCard'
import { useSelector } from 'react-redux'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'

const QuestionsSection = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    useDocumentTitle(`${assignmentName || ''} Questions`)

    return <QuestionsCard />
}

export default QuestionsSection
